import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchWithCSRFTokenForRequestObject } from "Utils/fetchWithCSRFToken";

import { appendAuthParams } from "Common/TokenAuth/Utils";

import { ChatAlertResponse, ChatSystemResponse, ChatRequest } from "Care/features/chat/chat.types";

export const chatApi = createApi({
  reducerPath: "chatApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/",
    fetchFn: fetchWithCSRFTokenForRequestObject,
  }),
  endpoints: (builder) => ({
    getEnrolledEmployeePolicies: builder.query<ChatEmployeePoliciesResponse, void>({
      query: (companyPolicyId) => appendAuthParams(`/openai/sbc_chatbot/enrolled_employee_policies/${companyPolicyId}`),
    }),
    sendQuestion: builder.mutation<ChatAlertResponse | ChatSystemResponse, ChatRequest>({
      query: ({ thread_id, new_question, company_policy_id, employee_policy_id }) => {
        return {
          url: appendAuthParams("/openai/sbc_chatbot"),
          method: "POST",
          params: {
            ...(company_policy_id ? { company_policy_id } : {}), // add company_policy_id if present
            ...(employee_policy_id ? { employee_policy_id } : {}), // add employee_policy_id if present
            ...(thread_id ? { thread_id } : {}), // add thread_id if present
          },
          body: { new_question },
        };
      },
    }),
  }),
});

export const { useGetEnrolledEmployeePoliciesQuery, useSendQuestionMutation } = chatApi;
